/**
 * Enum for standings momentum - if team is trending up/down/or not trending on the ledger
 */
export enum EStandingsMomentum {
	UP = "UP",
	DOWN = "DOWN",
	NEUTRAL = "NEUTRAL"
}
